import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { patchState, signalStore, withMethods, withProps, withState } from '@ngrx/signals';
import { SecurityAssetType } from '@pinnakl/securities/domain';
import { withDevtools } from '@pinnakl/shared/signal-store';
import { getErrorMessage } from '@pinnakl/shared/util-helpers';
import { PinnaklUIToastMessage } from '@pinnakl/shared/util-providers';
import { filter } from 'rxjs';
import { AssetTypesApiService } from './asset-types-api.service';

interface AssetTypesState {
  assetTypes: SecurityAssetType[];
  loading: boolean;
  loaded: boolean;
}

const initialState: AssetTypesState = {
  assetTypes: [],
  loading: false,
  loaded: false,
};

export const AssetTypesStore = signalStore(
  { providedIn: 'root' },
  withDevtools('assetTypes'),
  withState(initialState),
  withProps(store => ({
    loadedAssetTypes$: toObservable(store.assetTypes).pipe(filter(() => store.loaded())),
  })),
  withMethods((store, api = inject(AssetTypesApiService), toast = inject(PinnaklUIToastMessage)) => ({
    async loadAssetTypes(forceRefetch = false): Promise<void> {
      if (!forceRefetch && (store.loaded() || store.loading())) return;
      patchState(store, { loading: true });
      try {
        const assetTypes = await api.getAssetTypes();
        patchState(store, { assetTypes, loading: false, loaded: true });
      } catch (error) {
        toast.error(getErrorMessage('Something went wrong during asset types fetch', error));
        patchState(store, { loading: false });
      }
    },
  })),
);
